import React, { ReactNode } from 'react';

export enum EnumLinkType {
    EXTERNAL = 'external',
    DOWNLOAD = 'download'
}

export enum EnumLinkVariantValues {
    STANDARD = 'standard',
    REVERSED = 'reversed',
    NEUTRAL = 'neutral',
    BRAND = 'brand'
}

interface ILinkProps {
    // attributes
    analytics?: string;
    customSrOnly?: string;
    dark?: boolean;
    describedBy?: string;
    href: string;
    type?: EnumLinkType;
    variant?: EnumLinkVariantValues;
    children: ReactNode;
    // extra nous
    onClick?: () => void;
    dataTestId?: string;
}

/* cross-origin destinations are unsafe, adding rel https://web.dev/external-anchors-use-rel-noopener/ ++lighthouse */
export const Link: React.FC<ILinkProps> = ({
    // attributes
    analytics,
    customSrOnly,
    dark,
    describedBy,
    href,
    type,
    variant,
    children,
    // extra nous
    onClick,
    dataTestId
}) => {
    return (
        // @ts-ignore
        <dsd-link
            analytics={analytics}
            custom-sr-only={customSrOnly}
            dark={dark}
            described-by={describedBy}
            onClick={onClick}
            data-testId={dataTestId}
            type={type}
            variant={variant}
        >
            <a href={href}>{children}</a>
            {/* @ts-ignore */}
        </dsd-link>
    );
};
